export const RELEASE_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
export const RELEASE_REQUEST_HEADER = 'x-eb-web-client-release';
export const RELEASE_RESPONSE_HEADER = 'x-eb-web-release';
export const BUILD_RESPONSE_HEADER = 'x-eb-web-build';
export const DIGEST_RESPONSE_HEADER = 'x-eb-web-digest';

export const BUILD_ID = process.env.NEXT_PUBLIC_EB_WEB_RELEASE_ID || 'development';
export const RELEASE_ID = process.env.RELEASE_ID || BUILD_ID;
export const IMAGE_DIGEST = process.env.EB_WEB_IMAGE_DIGEST || 'unavailable';

export function isReleaseId(value: string | null): value is string {
  return value !== null && RELEASE_ID_PATTERN.test(value);
}
